import React, { useState, useEffect } from "react";
import api from "../../../api";
import Banner from "./include/Banner";

// Define the API URL
const API_URL = `${process.env.REACT_APP_API_URL}/api/research/mou`;
const API_BASE_URL = process.env.REACT_APP_API_URL;

const ResearchMou = () => {
  const [mouData, setMouData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch data from API
  useEffect(() => {
    const fetchMouData = async () => {
      try {
        const response = await api.get(API_URL);
        setMouData(response.data.mou);
      } catch (err) {
        console.error("Error fetching MoU data:", err);
        setError("Failed to load MoU data.");
      } finally {
        setLoading(false);
      }
    };

    fetchMouData();
  }, []);

  if (loading || error || !mouData) {
    return null;
  }

  const { images, heading, pdfs } = mouData.content;

  const defaultPdfIconPath = "/assets/images/pdf.webp";

  return (
    <>
      <Banner bannerImages={images} heading={heading} />

      <section>
        <div className="container ">
          <div className="row mb-5">
            <div className="col-md-12">
              <div className="res-content">
                <div className="sec-title text-center">
                  <h2> {heading}</h2>
                </div>

                <div className="row justify-content-center">
                  {pdfs.map((pdf, index) => (
                    <div key={index} className="col-md-4 col-12 mb-3">
                      <div className="card research-card d-flex flex-row shadow-sm">
                        {/* PDF Icon/Thumbnail */}
                        <div
                          className="p-2"
                          style={{
                            padding: "8px",
                            borderRight: "1px solid rgba(0, 0, 0, 0.125)",
                            borderRadius: "10px 0px 0px 10px",
                          }}
                        >
                          <img
                            src={defaultPdfIconPath} // Using the hardcoded icon path
                            alt="PDF Thumbnail"
                            className="img-fluid"
                            style={{
                              width: "70px",
                              height: "70px",
                              objectFit: "cover",
                            }}
                          />
                        </div>

                        {/* PDF Link */}
                        <div className="d-flex align-items-center p-2">
                          <a
                            // Construct the full URL for the PDF file
                            href={`${API_BASE_URL}/public/${pdf.file}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none text-dark"
                          >
                            <strong>{pdf.title}</strong>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}

                  {pdfs.length === 0 && (
                    <div className="col-12">
                      <p>
                        No Memorandum of Understanding documents available at
                        this time.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResearchMou;
